import axios from 'axios';
// import { Message } from 'element-ui';
import qs from 'qs';
// import router from '../../router';
// import { delCookie } from '#/js/cookie';
import { Message } from 'element-ui';

axios.defaults.baseURL = window.configPath.baseUrl;
import commonJs from "../../utils/common";
import { removePublicKey, removeToken } from "@/utils/auth";
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000; //请求过期时间
let loginOuttipsStatus = true; //登录提示状态 避免登录失效 重复提示
const noTokenUrlArr = [
  "/base/login/publicKey",
]; //免token接口

// 请求拦截
axios.interceptors.request.use(
  (config) => {
    // if (commonJs.getCookie("Token")) {
    //     loginOuttipsStatus = true;
    //     config.headers["access-token"] = commonJs.getCookie("Token"); // 添加token到请求头
    // } else {
    //     if (noTokenUrlArr.indexOf(config.url) === -1) {
    //         httpFn.noTokenLoginout();
    //     }
    // }
    return config;
  },
  (error) => {
    Promise.error(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200 && response.data.code === 200) {
      return Promise.resolve(response);
    } else if (response.status === 401) {
      //token过期
      httpFn.noTokenLoginout();
    } else {
      Message({
        message:
          response.message || response.data.message || "远程请求失败",
        type: "error",
      });
    }
    return Promise.reject(response);
  },
  (err) => {
    let errStr = err.toString();
    errStr.includes("401")
      ? httpFn.noTokenLoginout()
      : Message({ message: "远程请求失败", type: "error" });
  }
);

let httpFn = {
  //无token时的登录失效
  noTokenLoginout() {
    removeToken();
    removePublicKey();
    loginOuttipsStatus &&
      Message({
        message: "登录失效！请重新登录！",
        type: "error",
      });
    loginOuttipsStatus = false;
    location.href = `${location.origin}/#/login`;
  }
};

/* POST FORMDATA格式参数 */
export function postForm(url, params) {
  let par = {};
  if (params) {
    par = params;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(par), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.data);
    });
  });
};

/* 普通POST  */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.data);
    });
  });
};

/* POST  JSON字符串格式数据  */
export function postJson(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.data);
    });
  });
};


/* 普通get */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params,
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.data);
    });
  });
};


